import { Roles } from './role.model';

export class User {
  constructor(
    public id?: number,
    public email?: string,
    public isActive?: boolean,
    public locale?: string,
    public roles?: Roles[],
    public twoFactorEnabled?: boolean,
  ) { }

  static adapt(item: any): User {
    return new User(
      item.id,
      item.email,
      item.isActive,
      item.locale,
      item.roles,
      item.twoFactorEnabled,
    );
  }
}
